//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resetID } from '@/utils/generateID'
import toast from '@/utils/toast'
import { mapState } from 'vuex'
import Preview from '@/components/Editor/Preview'
import Save from '@/components/Editor/Save'
import { commonStyle, commonAttr } from '@/custom-component/component-list'
import eventBus from '@/utils/eventBus'
import { deepCopy } from '@/utils/utils'
import Zlib from 'zlib'

export default {
    components: { Preview, Save },
    data() {
        return {
            needToChange: [
                'top',
                'left',
                'width',
                'height',
                'fontSize',
                'borderWidth',
            ],
            scale: '100%',
            timer: null,
            showEdit: false
        }
    },
    computed: mapState([
        'componentData',
        'canvasStyleData',
        'areaData',
        'curComponent',
    ]),
    created() {
        eventBus.$on('preview', this.preview)
        eventBus.$on('save', this.save)
        eventBus.$on('clearCanvas', this.clearCanvas)

        this.scale = this.canvasStyleData.scale
    },
    methods: {
        format(value) {
            const scale = this.scale
            return value * parseInt(scale) / 100
        },

        getOriginStyle(value) {
            const scale = this.canvasStyleData.scale
            const result = value / (parseInt(scale) / 100)
            return result
        },

        handleScaleChange() {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                // 画布比例设一个最小值，不能为 0
                // eslint-disable-next-line no-bitwise
                this.scale = (~~this.scale) || 10
                const componentData = deepCopy(this.componentData)
                componentData.forEach(component => {
                    Object.keys(component.style).forEach(key => {
                        if (this.needToChange.includes(key)) {
                            // 根据原来的比例获取样式原来的尺寸
                            // 再用原来的尺寸 * 现在的比例得出新的尺寸
                            // 不能用 Math.round 防止 1 px 的边框变 0
                            component.style[key] = Math.ceil(this.format(this.getOriginStyle(component.style[key])))
                        }
                    })
                })

                this.$store.commit('setComponentData', componentData)
                this.$store.commit('setCanvasStyle', {
                    ...this.canvasStyleData,
                    scale: this.scale,
                })
            }, 1000)
        },

        lock() {
            this.$store.commit('lock')
        },

        unlock() {
            this.$store.commit('unlock')
        },

        compose() {
            this.$store.commit('compose')
            this.$store.commit('recordSnapshot')
        },

        decompose() {
            this.$store.commit('decompose')
            this.$store.commit('recordSnapshot')
        },

        undo() {
            this.$store.commit('undo')
        },

        redo() {
            this.$store.commit('redo')
        },

        preview() {
            this.$parent.isShowPreview = true
            this.$store.commit('setEditMode', 'preview')
        },

        getReceive(data) {
            this[data.key] = data.value
        },

        save() {
            let picNum = 0
            let iconNum = 0
            this.componentData.forEach(item => {
                if(item.component == 'v-icon') {
                    iconNum = iconNum + 1
                } else if(item.component == 'Picture') {
                    picNum = picNum + 1
                }
            })
            if(iconNum > 10) {
                toast('最多只能添加十张图标')
                return
            } else if(picNum > 10) {
                toast('最多只能添加十张图片')
                return
            }

            console.log(JSON.stringify(this.componentData))
            console.log(JSON.stringify(this.canvasStyleData))

            this.showEdit = true
            
            // localStorage.setItem('canvasData', JSON.stringify(JSON.stringify(this.componentData)))
            // localStorage.setItem('canvasStyle', JSON.stringify(this.canvasStyleData))
            // this.$message.success('保存成功')
        },

        clearCanvas() {
            this.$store.commit('setCurComponent', { component: null, index: null })
            this.$store.commit('setComponentData', [])
            this.$store.commit('recordSnapshot')
            resetID()
        },

        // handlePreviewChange() {
        //     this.$store.commit('setEditMode', 'edit')
        // },

        zip(str){
            // zlib压缩
            var deflate = Zlib.deflateSync(str, {level: 9})
            return deflate.toString('base64')
        },
    },
}
